// import { ServiceEvent } from "../../../../types/Service";
// import { presenters } from "../../data/presenters";
import { createSlide } from "../../slidesOps/createSlide";
// import { getPageId } from "../../state/pageId";
import "./temp.scss";
// To Do: override temp?
export function slideGospelMeetingTEMP() {
    // const html = `
    //     <article class="summer-singing">
    //         <div class="content">
    //             <h1 class="event-title">Summer Singing</h1>
    //             <h3 class="event-theme">
    //                 <strong>Ring Out</strong>
    //                 The Message
    //             </h3>
    //             <p class="date-time">Friday, August 9 • 7:00 PM</p>
    //             <br />
    //             <div class="cta">
    //                 ${summerSinging2024QRCode()}
    //                 <div class="right">
    //                     <p>
    //                         <strong>Mark Your Calendar!</strong><br />https://bit.ly/2024-summer-singing
    //                     </p>
    //                 </div>
    //             </div>
    //         </div>
    //         <div class="summer-singing__bg">
    //             <img src="https://www.cedarparkchurchofchrist.org/media/uploads/public/gospel-meeting/2024-summer-singing/globe.png" alt="World Globe" />
    //         </div>
    //     </article>
    // `
    // return createSlide(
    //     {
    //         wrap: 'false',
    //         center: 'false',
    //         autoslide: 30000,
    //         html,
    //         background: {
    //             gradient: "linear-gradient(90deg, #fff 0%, rgba(229, 210, 200, 1) 100%)",
    //         },
    //     },
    //     "gospel-meeting-temp",
    // );
    // const service = schedule[0];
    // const startDate = service.date;
    // const endDate = schedule[schedule.length - 1].date;
    // const presenter = presenters[service.presenter]
    // const html = `
    //     <!--<p class="reminder">
    //         <i class="fa-regular fa-calendar"></i>
    //         Mark Your Calendars
    //     </p>-->
    //     <div class="meeting-group">
    //         <p class="meeting-type">Gospel Meeting</p>
    //         <p class="presenter">with ${presenter.name}</p>
    //         <p class="date">
    //             <span class="month">${window.months[startDate.getMonth()]}</span>
    //             <span class="start-date">${startDate.getDate()}</span>
    //             <span class="hyphen">-</span>
    //             <span class="end-date">${endDate.getDate()}</span>
    //         </p>
    //     </div>
    // `;
    createSlide({
        autoslide: 30000,
        background: {
            color: "#000",
            image: "https://www.cedarparkchurchofchrist.org/media/uploads/src/board/THEME%20FOCUS%20PPT%20slide%2016-9.png",
        },
    }, "gospel-meeting-temp");
}
